const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL || '';

const apiFetch = async (path, options = {}) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${getBaseUrl()}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      message = body.error || body.message || message;
    } catch { /* ignore */ }
    throw new Error(message);
  }
  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const fetchDuplicateWarnings = async (tenantId) => {
  if (!tenantId) return [];
  const warnings = await apiFetch(`conductor/payment-duplicate-warnings?tenant_id=${tenantId}`).catch(() => []);
  return Array.isArray(warnings) ? warnings : [];
};

const postAction = (path, body) => apiFetch(path, {
  method: 'POST',
  body: JSON.stringify(body),
});

export const dismissDuplicateWarning = (body) => postAction(
  'conductor/payment-duplicate-warnings/dismiss',
  body,
);

export const acknowledgeDuplicateWarning = (body) => postAction(
  'conductor/payment-duplicate-warnings/acknowledge',
  body,
);

export const voidDuplicatePayment = (body) => postAction(
  'conductor/payment-duplicate-warnings/void',
  body,
);

export const warningLabel = (warning) => `Possible duplicate – ${warning?.reason || 'match'}`;

export const warningsForPaymentIds = (warnings = [], paymentIds = []) => {
  const ids = new Set((paymentIds || []).filter(Boolean).map(String));
  if (!ids.size) return [];
  return warnings.filter((warning) => ids.has(String(warning.paymentId)));
};

export const warningsForInvoice = (warnings = [], apInvoiceId) => {
  if (!apInvoiceId) return [];
  return warnings.filter((warning) => String(warning.apInvoiceId) === String(apInvoiceId));
};
